// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cbd1b867","703":"17a66642"}[chunkId] + ".chunk.js";
};